




















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import List from '@/components/util/List.vue';
import { ColumnDisplayOption } from '@/models/ColumnDisplayOption';
import { SortChangedEvent } from '@/models/SortChangedEvent';

import { WorkordersApi, Workorder } from 'performo-api';
import { mapGetters } from 'vuex';
import { User } from 'oidc-client';

@Component({
  components: {
    List
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser'
  })
})
export default class AssetOrderHistory extends Vue {
  @Prop({ required: true }) assetId!: number;
  @Prop({ required: false }) columnDisplay!: ColumnDisplayOption[];
  @Prop({ required: false, default: 'No work order history to display.' })
  zeroCountDisplayMessage!: string;

  private loading = false;

  private api = new WorkordersApi(this.$store.getters.getApiConfiguration);
  private orders?: Workorder[];
  private internalPageNumber = 0;

  private currentPropertyId!: string;
  private currentUser!: User;

  data() {
    return {
      orders: undefined
    };
  }

  get columnDisplayComputed(): ColumnDisplayOption[] {
    // this computed value uses the incoming prop if defined, but if not uses a sensible default.
    return this.columnDisplay
      ? this.columnDisplay
      : [
          {
            displayName: 'Order #',
            columnName: 'orderNumber',
            width: '100px',
            dontSort: true
          },
          {
            displayName: 'Type',
            columnName: 'orderCategory',
            width: '80px',
            dontSort: true
          },
          {
            displayName: 'Status',
            columnName: 'orderStatus',
            dontSort: true
          },
          {
            displayName: 'Order By',
            columnName: 'orderBy',
            dontSort: true
          },
          {
            displayName: 'Assigned To',
            columnName: 'assignTo',
            dontSort: true
          },
          {
            displayName: 'Description',
            columnName: 'description',
            width: '200px',
            dontSort: true
          },
          {
            displayName: 'Start',
            columnName: 'startDateTime',
            formatKind: 1,
            dontSort: true
          },
          {
            displayName: 'Complete',
            columnName: 'completionDateTime',
            formatKind: 1,
            dontSort: true
          }
        ];
  }

  private outputModeOverride!: string;

  private sortChangedHandler(sort: SortChangedEvent) {
    this.$emit('sort-changed', sort);

    // sort changed, re-fetch the data from the server
    this.fetchAssetOrders();
  }

  private goPageForward() {
    // do page forward things
    this.internalPageNumber += 1;
    this.paginationChangeHandler(this.internalPageNumber);
  }

  private goPageBackward() {
    // do page forward things
    this.internalPageNumber -= 1;
    this.paginationChangeHandler(this.internalPageNumber);
  }

  private paginationChangeHandler(pageNumber: number) {
    pageNumber;
    // this.documentsQuery.skip = (this.pageSize * pageNumber) + 1;

    this.fetchAssetOrders();
  }

  private async listRowClickedHandler(item: Workorder) {
    if (item.workorderId) {
      this.$router.push({
        name: 'work-order-detail',
        params: { id: item.workorderId }
      });
    }
  }

  @Watch('assetId')
  private async assetChanged(val: number) {
    if (val) {
      // val.skip = 0; // always reset to beginning
      // this.internalPageNumber = 0;
      this.fetchAssetOrders();
    }
  }

  private fetchAssetOrders() {
    this.loading = true;
    this.api
      .assetOrderHistory({ assetId: this.assetId })
      .then((o) => (this.orders = o))
      .finally(() => (this.loading = false));
  }

  private mounted() {
    // load data
    this.fetchAssetOrders();
  }
}
